module.exports = __webpack_public_path__ + "static/media/YM02_0.7d7907a9.jpg";